export default __webpack_public_path__ + "static/media/markus-spiske-MI9-PY5cyNs-unsplash.3e1cde2c.jpg";